import styles from './career.module.css';

export default function CareerFooter() {
  return (
    <div className={styles.footer}>
      {/* Wave Background */}
      <div className={styles.waveContainer}>
        <div className={styles.wave}></div>
        <div className={`${styles.wave} ${styles.wave2}`}></div>
      </div>

      {/* Footer Content */}
      <div className={styles.content}>
        <h3 className={styles.heading}>Working Hours/Days</h3>
        <div className={styles.columns}>
          <div>
            <strong>India (Head Office) and Other Domestic Offices:</strong>
            <p>
              6 days a week (Monday to Saturday)<br />
              Except 2nd and 4th Saturday
            </p>
          </div>

          <div>
            <strong>Overseas</strong>
            <p>Monday – Friday</p>
          </div>

          <div>
            <strong>Manufacturing Plants</strong>
            <p>Monday – Saturday</p>
          </div>
        </div>
      </div>
    </div>
  );
}
